import React from "react";

import AdvancedFeatures from "../components/AboutUs/AdvancedFeatures";
import Banner from "../components/AboutUs/Banner";
import BuiltFor from "../components/AboutUs/BuiltFor";
import EducationDark from "../components/AboutUs/EducationDark";
import EducationLight from "../components/AboutUs/EducationLight";
import PlatformAdvantages from "../components/AboutUs/PlatformAdvantages";
import Regulation from "../components/AboutUs/Regulation";
import Security from "../components/AboutUs/Security";
import Assistance from "../components/Home/Assistance";

function AboutUs() {
  return (
    <main className="overflow-hidden bg-white">
      <Banner />
      <Regulation />
      <BuiltFor />
      <PlatformAdvantages />
      <EducationDark />
      <EducationLight />
      <AdvancedFeatures />
      <Security />
      <div className="mt-[80px] xl:mt-[160px]">
        <Assistance />
      </div>
    </main>
  );
}

export default AboutUs;
